import React, { useState, useEffect } from 'react';
import AdminSidebar from '../../components/AdminSidebar';
import AdminHeader from '../../components/AdminHeader';
import './ManageRestaurants.css';

// Données fictives pour la démonstration
const demoRestaurants = [
  { id: 1, name: "Le Gourmet", logo: "/images/restaurants/le-gourmet.jpg", description: "Cuisine française raffinée", location: "Paris 8ème", items: 42, rating: 4.8, status: "actif" },
  { id: 2, name: "Pizza Express", logo: "/images/restaurants/pizza-express.jpg", description: "Les meilleures pizzas italiennes", location: "Paris 11ème", items: 28, rating: 4.5, status: "actif" },
  { id: 3, name: "Sushi Master", logo: "/images/restaurants/sushi-master.jpg", description: "Spécialités japonaises", location: "Paris 15ème", items: 35, rating: 4.7, status: "actif" },
  { id: 4, name: "Le Kebab Royal", logo: "/images/restaurants/kebab-royal.jpg", description: "Cuisine orientale authentique", location: "Paris 18ème", items: 20, rating: 4.2, status: "inactif" },
  { id: 5, name: "Burger House", logo: "/images/restaurants/burger-house.jpg", description: "Burgers gourmets et frites maison", location: "Paris 5ème", items: 25, rating: 4.6, status: "actif" },
];

const ManageRestaurants = () => {
  const [restaurants, setRestaurants] = useState(demoRestaurants);
  const [searchTerm, setSearchTerm] = useState('');
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedRestaurant, setSelectedRestaurant] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    location: '',
    logo: null,
    status: 'actif'
  });
  
  // Filtrer les restaurants selon le terme de recherche
  const filteredRestaurants = restaurants.filter(restaurant => 
    restaurant.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
    restaurant.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
    restaurant.location.toLowerCase().includes(searchTerm.toLowerCase())
  );
  
  // Simuler un chargement de données depuis une API
  useEffect(() => {
    // Dans un cas réel, vous feriez un appel API ici
    // fetch('/api/admin/restaurants')
    //   .then(response => response.json())
    //   .then(data => setRestaurants(data));
  }, []);
  
  const handleToggleStatus = (restaurantId) => {
    setRestaurants(restaurants.map(restaurant => {
      if (restaurant.id === restaurantId) {
        return {
          ...restaurant,
          status: restaurant.status === 'actif' ? 'inactif' : 'actif'
        };
      }
      return restaurant;
    }));
  };
  
  const handleAddRestaurant = () => {
    setFormData({
      name: '',
      description: '',
      location: '',
      logo: null,
      status: 'actif'
    });
    setShowAddModal(true);
  };
  
  const handleEditRestaurant = (restaurant) => {
    setSelectedRestaurant(restaurant);
    setFormData({
      name: restaurant.name,
      description: restaurant.description,
      location: restaurant.location,
      logo: null, // We'd normally set this to the existing logo URL
      status: restaurant.status
    });
    setShowEditModal(true);
  };
  
  const handleDeleteRestaurant = (restaurantId) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer ce restaurant ?")) {
      setRestaurants(restaurants.filter(restaurant => restaurant.id !== restaurantId));
    }
  };
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  
  const handleFileChange = (e) => {
    setFormData({
      ...formData,
      logo: e.target.files[0]
    });
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (showAddModal) {
      // Add new restaurant logic
      const newRestaurant = {
        id: restaurants.length + 1,
        name: formData.name,
        description: formData.description,
        location: formData.location,
        logo: formData.logo ? URL.createObjectURL(formData.logo) : "/images/restaurants/placeholder.jpg",
        items: 0,
        rating: 0,
        status: formData.status
      };
      
      setRestaurants([...restaurants, newRestaurant]);
      setShowAddModal(false);
    } else if (showEditModal && selectedRestaurant) {
      // Edit restaurant logic
      setRestaurants(restaurants.map(restaurant => {
        if (restaurant.id === selectedRestaurant.id) {
          return {
            ...restaurant,
            name: formData.name,
            description: formData.description,
            location: formData.location,
            logo: formData.logo ? URL.createObjectURL(formData.logo) : restaurant.logo,
            status: formData.status
          };
        }
        return restaurant;
      }));
      
      setShowEditModal(false);
      setSelectedRestaurant(null);
    }
  };
  
  const closeModal = () => {
    setShowAddModal(false);
    setShowEditModal(false);
    setSelectedRestaurant(null);
  };

  return (
    <div className="admin-dashboard">
      <AdminSidebar />
      <div className="dashboard-content">
        <AdminHeader title="Gestion des Restaurants" />
        
        <div className="restaurants-container">
          <div className="action-bar">
            <div className="search-box">
              <input 
                type="text" 
                placeholder="Rechercher un restaurant..." 
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <button className="search-button">Rechercher</button>
            </div>
            
            <button className="add-restaurant-button" onClick={handleAddRestaurant}>
              Ajouter un Restaurant
            </button>
          </div>
          
          <div className="restaurants-grid">
            {filteredRestaurants.map(restaurant => (
              <div key={restaurant.id} className={`restaurant-card ${restaurant.status === 'inactif' ? 'inactive' : ''}`}>
                <div className="restaurant-card-header">
                  <div className="restaurant-logo">
                    <img src={restaurant.logo} alt={restaurant.name} />
                  </div>
                  <div className="restaurant-status">
                    <span className={`status-badge ${restaurant.status === 'actif' ? 'status-active' : 'status-inactive'}`}>
                      {restaurant.status}
                    </span>
                  </div>
                </div>
                
                <div className="restaurant-card-body">
                  <h3>{restaurant.name}</h3>
                  <p className="restaurant-description">{restaurant.description}</p>
                  <p className="restaurant-location">📍 {restaurant.location}</p>
                  
                  <div className="restaurant-stats">
                    <div className="stat">
                      <span className="stat-label">Plats</span>
                      <span className="stat-value">{restaurant.items}</span>
                    </div>
                    <div className="stat">
                      <span className="stat-label">Note</span>
                      <span className="stat-value">{restaurant.rating} ⭐</span>
                    </div>
                  </div>
                </div>
                
                <div className="restaurant-card-footer">
                  <button className="action-button edit-button" onClick={() => handleEditRestaurant(restaurant)}>
                    Modifier
                  </button>
                  <button 
                    className={`action-button ${restaurant.status === 'actif' ? 'deactivate-button' : 'activate-button'}`}
                    onClick={() => handleToggleStatus(restaurant.id)}
                  >
                    {restaurant.status === 'actif' ? 'Désactiver' : 'Activer'}
                  </button>
                  <button className="action-button items-button" onClick={() => window.location.href = `/admin/restaurants/${restaurant.id}/items`}>
                    Plats
                  </button>
                  <button className="action-button delete-button" onClick={() => handleDeleteRestaurant(restaurant.id)}>
                    Supprimer
                  </button>
                </div>
              </div>
            ))}
          </div>
          
          {/* Modal pour ajouter/modifier un restaurant */}
          {(showAddModal || showEditModal) && (
            <div className="modal-backdrop">
              <div className="restaurant-modal">
                <button className="close-modal" onClick={closeModal}>×</button>
                <h2>{showAddModal ? 'Ajouter un Restaurant' : 'Modifier le Restaurant'}</h2>
                
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="name">Nom du Restaurant</label>
                    <input 
                      type="text" 
                      id="name" 
                      name="name" 
                      value={formData.name} 
                      onChange={handleInputChange}
                      required 
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="description">Description</label>
                    <textarea 
                      id="description" 
                      name="description" 
                      value={formData.description} 
                      onChange={handleInputChange}
                      required
                    ></textarea>
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="location">Adresse</label>
                    <input 
                      type="text" 
                      id="location" 
                      name="location" 
                      value={formData.location} 
                      onChange={handleInputChange}
                      required 
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="logo">Logo</label>
                    <input 
                      type="file" 
                      id="logo" 
                      name="logo" 
                      accept="image/*" 
                      onChange={handleFileChange}
                      required={showAddModal} 
                    />
                    {showEditModal && <p className="hint">Laissez vide pour conserver l'image actuelle</p>}
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="status">Statut</label>
                    <select 
                      id="status" 
                      name="status" 
                      value={formData.status} 
                      onChange={handleInputChange}
                    >
                      <option value="actif">Actif</option>
                      <option value="inactif">Inactif</option>
                    </select>
                  </div>
                  
                  <div className="form-actions">
                    <button type="button" className="cancel-button" onClick={closeModal}>Annuler</button>
                    <button type="submit" className="submit-button">
                      {showAddModal ? 'Ajouter' : 'Enregistrer les modifications'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ManageRestaurants;